module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/content.component.html
// module id = ../../../../../src/app/main/content/content.component.html
// module chunks = main